import React, { useState, useEffect } from 'react';
import { Box, Paper, Stack, ToggleButton, ToggleButtonGroup, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import AvailabilityOverview from './AvailabilityOverview';
import EmployeeAvailability from './EmployeeAvailability';
import AvailabilityCalendarEditor from './v2/AvailabilityCalendarEditor';
import { API_URL } from '../utils/apiConfig';

export default function AvailabilityPage() {
  const [tab, setTab] = useState('overview');
  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState('all');

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const token = localStorage.getItem('token');
        const resp = await fetch(`${API_URL.replace(/\/$/, '')}/vnext/locations`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const data = await resp.json();
        if (resp.ok) {
          setLocations(data.data || []);
        }
      } catch (e) {
        console.error('Error fetching locations:', e);
      }
    };
    fetchLocations();
  }, []);

  return (
    <Box sx={{ m: 2 }}>
      <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 2 }}>
        <ToggleButtonGroup value={tab} exclusive onChange={(e, v)=>{ if (v) setTab(v); }}>
          <ToggleButton value="overview">Overview</ToggleButton>
          <ToggleButton value="editor">Editor</ToggleButton>
        </ToggleButtonGroup>

        <FormControl size="small" sx={{ minWidth: 140 }}>
          <InputLabel>Location</InputLabel>
          <Select value={selectedLocation} onChange={(e) => setSelectedLocation(e.target.value)} label="Location">
            <MenuItem value="all">All Locations</MenuItem>
            {locations.map(loc => (
              <MenuItem key={loc.id} value={loc.id}>{loc.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>
      <Paper variant="outlined">
        {tab === 'overview' ? (
          <AvailabilityOverview selectedLocation={selectedLocation} />
        ) : (
          <AvailabilityCalendarEditor isManager={true} selectedLocation={selectedLocation} />
        )}
      </Paper>
    </Box>
  );
}

